"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processLawRef = void 0;
const error_1 = require("../../parser/cst/error");
const controls_1 = require("../../node/el/controls");
const _lawRef_1 = __importDefault(require("../sentenceChildrenParser/rules/$lawRef"));
const env_1 = require("../sentenceChildrenParser/env");
const sentenceEnv_1 = require("../../node/container/sentenceEnv");
const std = __importStar(require("../../law/std"));
const getScope_1 = __importDefault(require("../pointerEnvs/getScope"));
const lawNum_1 = require("../../law/lawNum");
const getSuggestedLawTitleInfo = (options) => {
    const errors = [];
    const { lawRefResult, sentenceEnv } = options;
    const { lawTitleCandidates, lawRefInfo: { lawNum } } = lawRefResult;
    const lawTitleLength = options.lawTitleLength((0, lawNum_1.lawNumLikeToLawNum)(lawNum.text()));
    if (!lawTitleLength) {
        errors.push(new error_1.ErrorMessage("Could not find lawTitleLength", sentenceEnv.textRageOfEL(lawNum) ?? [0, 0]));
        return { errors };
    }
    const lawTitleCandidateTexts = lawTitleCandidates.map(c => {
        if (std.isRuby(c)) {
            return c.children.filter(cc => !std.isRt(cc)).map(cc => typeof cc === "string" ? cc : cc.text()).join("");
        }
        else {
            return c.text();
        }
    });
    let candidateStartTextRangeStart = (lawTitleCandidates && sentenceEnv.textRageOfEL(lawTitleCandidates[0])?.[0]) ?? 0;
    let candidateStartRestLength = 0;
    let lawTitleCandidatestartIndex = lawTitleCandidateTexts.length - 1;
    for (let i = lawTitleCandidateTexts.length - 1; 0 <= i; i--) {
        const candidateLength = lawTitleCandidateTexts.slice(i).reduce(((a, b) => a + b.length), 0);
        if (candidateLength >= lawTitleLength) {
            const c = lawTitleCandidates[i];
            const range = sentenceEnv.textRageOfEL(c);
            lawTitleCandidatestartIndex = i;
            if (std.isRuby(c)) {
                if (range)
                    candidateStartTextRangeStart = range[0];
                candidateStartRestLength = 0;
            }
            else if (range) {
                candidateStartTextRangeStart = range[0] + (candidateLength - lawTitleLength);
                candidateStartRestLength = candidateLength - lawTitleLength;
            }
            break;
        }
    }
    const lawTitleStartEL = lawTitleCandidates[lawTitleCandidatestartIndex];
    const lawTitleCandidateTextStartRange = sentenceEnv.textRageOfEL(lawTitleStartEL);
    const lawTitleCandidateTextEndRange = sentenceEnv.textRageOfEL(lawTitleCandidates[lawTitleCandidates.length - 1]);
    const lawTitleCandidateTextRange = lawTitleCandidateTextStartRange && lawTitleCandidateTextEndRange && [lawTitleCandidateTextStartRange[0], lawTitleCandidateTextEndRange[1]];
    if (!lawTitleCandidateTextRange) {
        errors.push(new error_1.ErrorMessage("lawTitleCandidateTextRange is null", [
            sentenceEnv.textRageOfEL(lawTitleCandidates[0])?.[0] ?? 0,
            sentenceEnv.textRageOfEL(lawTitleCandidates[lawTitleCandidates.length - 1])?.[1] ?? 0,
        ]));
        return { errors };
    }
    const suggestedLawTitle = lawTitleCandidateTexts.slice(lawTitleCandidatestartIndex).join("").slice(-lawTitleLength);
    const replacer = {
        children: [
            ...((std.isRuby(lawTitleStartEL) || candidateStartRestLength === 0) ? [lawTitleStartEL] : [
                new controls_1.__Text(lawTitleStartEL.text().slice(candidateStartRestLength), lawTitleStartEL.range && [
                    lawTitleStartEL.range[0] + candidateStartRestLength,
                    lawTitleStartEL.range[1],
                ]),
            ]),
            ...lawTitleCandidates.slice(lawTitleCandidatestartIndex + 1),
        ],
        range: lawTitleStartEL.range && [
            lawTitleStartEL.range[0] + candidateStartRestLength,
            lawTitleCandidates[lawTitleCandidates.length - 1].range?.[1] ?? 0,
        ],
        restText: (std.isRuby(lawTitleStartEL) || candidateStartRestLength === 0) ? null : (new controls_1.__Text(lawTitleStartEL.text().slice(0, candidateStartRestLength), lawTitleStartEL.range && [
            lawTitleStartEL.range[0],
            lawTitleStartEL.range[0] + candidateStartRestLength,
        ])),
        replacedCount: lawTitleCandidates.length - lawTitleCandidatestartIndex,
    };
    return {
        value: {
            suggestedLawTitle,
            candidateStartTextRangeStart,
            candidateStartRestLength,
            lawTitleStartEL,
            lawTitleCandidatestartIndex,
            lawTitleCandidateTextRange,
            replacer,
        },
        errors,
    };
};
const processLawRef = (elToBeModified, sentenceEnv, sentenceEnvsStruct, pointerEnvsStruct, lawTitleLength) => {
    const errors = [];
    const declarations = [];
    const lawRefs = [];
    for (let i = 0; i < elToBeModified.children.length; i++) {
        if (elToBeModified.children[i] instanceof controls_1.____LawNum) {
            // e.g. "...日本国憲法..."
            //      -> lawRef is for "日本国憲法"
            const lawNum = elToBeModified.children[i];
            const lawNumLikeText = lawNum.text();
            const lawNumText = (0, lawNum_1.lawNumLikeToLawNum)(lawNumLikeText);
            const lawRef = new controls_1.____LawRef({
                range: lawNum.range,
                lawNum: (0, lawNum_1.lawNumLikeToLawNum)(lawNum.text()),
                ...((lawNumLikeText !== lawNumText)
                    ? {
                        suggestedLawTitle: lawNumLikeText,
                    }
                    : {}),
            });
            lawRefs.push(lawRef);
            lawRef.children.push(lawNum);
            elToBeModified.children.splice(i, 1, lawRef);
            continue;
        }
        const result = _lawRef_1.default.match(i, elToBeModified.children, (0, env_1.initialEnv)({ target: "" }));
        if (!result.ok)
            continue;
        errors.push(...result.value.errors);
        const lawRefResult = result.value.value;
        const { lawRefInfo: { aliasInfo, lawNum } } = lawRefResult;
        const lawNumText = lawNum.text();
        const SuggestedLawTitleInfo = getSuggestedLawTitleInfo({
            lawRefResult,
            sentenceEnv,
            lawTitleLength,
        });
        errors.push(...SuggestedLawTitleInfo.errors);
        // e.g. "...電気通信事業法（昭和五十九年法律第八十六号。以下「法」という。）..."
        //      -> lawRef is for "電気通信事業法（昭和五十九年法律第八十六号。以下「法」という。）"
        // e.g. "...独立行政法人通則法の一部を改正する法律（平成二十六年法律第六十六号。以下「通則法改正法」という。）..."
        //      -> if the length of LawTitle could not be found, lawRef is for "（平成二十六年法律第六十六号。以下「通則法改正法」という。）"
        const lawRef = new controls_1.____LawRef({
            range: ((SuggestedLawTitleInfo.value)
                ? [
                    SuggestedLawTitleInfo.value.replacer.range?.[0] ?? 0,
                    lawRefResult.lawRefInfo.lawRefParentheses.range?.[1] ?? 0,
                ]
                : lawRefResult.lawRefInfo.lawRefParentheses.range),
            lawNum: lawNumText,
            ...(SuggestedLawTitleInfo.value?.suggestedLawTitle
                ? {
                    suggestedLawTitle: SuggestedLawTitleInfo.value.suggestedLawTitle,
                }
                : {}),
        });
        lawRefs.push(lawRef);
        if (aliasInfo) {
            // e.g. "...電気通信事業法（昭和五十九年法律第八十六号。以下「法」という。）..."
            //      -> declaration is for "法"
            const { nameSquareParentheses, following, pointerRanges } = aliasInfo;
            if (pointerRanges)
                (0, getScope_1.default)({ pointerRangesToBeModified: pointerRanges, pointerEnvsStruct });
            const aliasName = nameSquareParentheses.content.text();
            const followingStartPos = following ? {
                sentenceIndex: sentenceEnv.index,
                textOffset: sentenceEnv.textRageOfEL(nameSquareParentheses)?.[1] ?? 0,
            } : null;
            const scope = (0, sentenceEnv_1.toSentenceTextRanges)(pointerRanges?.targetContainerIDRanges ?? null, sentenceEnvsStruct, followingStartPos);
            if (scope.length === 0) {
                errors.push(new error_1.ErrorMessage("No scope found", [
                    pointerRanges?.range?.[0] ?? 0,
                    pointerRanges?.range?.[1] ?? 0,
                ]));
            }
            const aliasNameTextRange = sentenceEnv.textRageOfEL(nameSquareParentheses.content);
            if (!aliasNameTextRange) {
                errors.push(new error_1.ErrorMessage("aliasNameTextRange is null", [
                    pointerRanges?.range?.[0] ?? 0,
                    pointerRanges?.range?.[1] ?? 0,
                ]));
                continue;
            }
            const nameSentenceTextRange = {
                start: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: aliasNameTextRange[0],
                },
                end: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: aliasNameTextRange[1],
                },
            };
            const declarationID = `decl-sentence_${sentenceEnv.index}-text_${aliasNameTextRange[0]}_${aliasNameTextRange[1]}`;
            const declaration = new controls_1.____Declaration({
                declarationID,
                type: "LawTitle",
                name: aliasName,
                value: {
                    isCandidate: false,
                    text: lawNumText,
                    sentenceTextRange: ((start, end) => ({ start: { sentenceIndex: sentenceEnv.index, textOffset: start }, end: { sentenceIndex: sentenceEnv.index, textOffset: end } }))(...sentenceEnv.textRageOfEL(lawNum) ?? [0, 0]),
                },
                scope: scope,
                nameSentenceTextRange,
                range: nameSquareParentheses.content.range,
                children: [aliasName],
            });
            declarations.push(declaration);
            lawRef.attr.includingDeclarationID = declarationID;
            nameSquareParentheses.content.children.splice(0, nameSquareParentheses.content.children.length, declaration);
            lawRef.children.push(...[
                ...(SuggestedLawTitleInfo.value?.replacer.children ?? []),
                lawRefResult.lawRefInfo.lawRefParentheses,
            ]);
        }
        else {
            // e.g. "...電気通信事業法（昭和五十九年法律第八十六号）..."
            //      -> aliasInfo does not exist. declaration is for "電気通信事業法".
            // e.g. "...独立行政法人通則法の一部を改正する法律（平成二十六年法律第六十六号）..."
            //      -> if the length of LawTitle could not be found, declaration is not generated.
            const scope = [
                {
                    start: {
                        sentenceIndex: sentenceEnv.index,
                        textOffset: sentenceEnv.textRageOfEL(lawNum)?.[1] ?? 0,
                    },
                    end: {
                        sentenceIndex: sentenceEnvsStruct.rootContainer.sentenceRange[1],
                        textOffset: 0,
                    },
                },
            ];
            if (SuggestedLawTitleInfo.value) {
                const { suggestedLawTitle, candidateStartTextRangeStart, lawTitleCandidateTextRange, replacer, } = SuggestedLawTitleInfo.value;
                const nameSentenceTextRange = {
                    start: {
                        sentenceIndex: sentenceEnv.index,
                        textOffset: candidateStartTextRangeStart,
                    },
                    end: {
                        sentenceIndex: sentenceEnv.index,
                        textOffset: lawTitleCandidateTextRange[1],
                    },
                };
                const declarationID = `decl-sentence_${sentenceEnv.index}-text_${nameSentenceTextRange.start.textOffset}_${nameSentenceTextRange.end.textOffset}`;
                const declaration = new controls_1.____Declaration({
                    declarationID,
                    type: "LawTitle",
                    name: suggestedLawTitle,
                    value: {
                        isCandidate: false,
                        text: lawNumText,
                        sentenceTextRange: ((start, end) => ({ start: { sentenceIndex: sentenceEnv.index, textOffset: start }, end: { sentenceIndex: sentenceEnv.index, textOffset: end } }))(...sentenceEnv.textRageOfEL(lawNum) ?? [0, 0]),
                    },
                    scope: scope,
                    nameSentenceTextRange,
                    children: replacer.children,
                    range: replacer.range,
                });
                declarations.push(declaration);
                lawRef.attr.includingDeclarationID = declarationID;
                lawRef.children.push(declaration);
            }
            lawRef.children.push(lawRefResult.lawRefInfo.lawRefParentheses);
        }
        if (SuggestedLawTitleInfo.value) {
            const { lawTitleCandidatestartIndex, replacer, } = SuggestedLawTitleInfo.value;
            elToBeModified.children.splice(i + lawTitleCandidatestartIndex, replacer.replacedCount + 1, ...(replacer.restText
                ? [replacer.restText]
                : []), lawRef);
            i += replacer.replacedCount - 1;
        }
        else {
            const replacingIndex = elToBeModified.children.indexOf(result.value.value.lawRefInfo.lawRefParentheses);
            elToBeModified.children.splice(replacingIndex, 1, lawRef);
        }
    }
    return {
        value: { declarations, lawRefs },
        errors,
    };
};
exports.processLawRef = processLawRef;
//# sourceMappingURL=processLawRef.js.map